var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(-971 -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(971 407)",
    fill: "#fff",
    stroke: "#a3d7ee",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(8.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y2: 10,
    transform: "translate(971.5 414)",
    fill: "none",
    stroke: "#a3d7ee",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M13541.5-16429h7.979l-2.006,2.553,2.006,2.414h-7.979",
    transform: "translate(-12570 16843)",
    fill: "none",
    stroke: "#a3d7ee",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 2,
    transform: "translate(970.5 424.5)",
    fill: "none",
    stroke: "#a3d7ee",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagInactive);
export default __webpack_public_path__ + "static/media/flag_inactive.e819fcfee9ecd6b9f58a4a387f81b5b2.svg";
export { ForwardRef as ReactComponent };